export const ORDER_TYPE= {
    ORDER_ROOM:{
        label:'房间订单',
        value:1
    },
    // ORDER_MEAL:{
    //     label:'套餐订单',
    //     value:2
    // },
    ORDER_TIME:{
        label:'加时订单',
        value:3
    },
    ORDER_PRODUCT:{
        label:'商品订单',
        value:4
    },
    ORDER_BALANCE:{
        label:'充值订单',
        value:5
    },
    ORDER_SCAN:{
        label:'扫码支付订单',
        value:6
    },
    ORDER_PIA_PRODUCT:{
        label:'货柜订单',
        value:7
    },
    ORDER_STORE_PRODUCT:{
        label:'门店产品订单',
        value:8
    },
}